import type { InjectionKey } from 'vue';

/** 悬浮窗把大图交给外层页面浮出；工作台不提供这项能力。 */
export interface ImagePreviewHost {
  /** 外层已经浮出大图时返回 true。 */
  open(file: File): Promise<boolean>;
  close(): void;
}

export const imagePreviewHostKey: InjectionKey<ImagePreviewHost> = Symbol('imagePreviewHost');
